import React from "react";

const TranslationProcess = () => {
  return (
    <div className="transHeadContent">
      <h2>Our Process </h2>
      <p>
        Our translation process is streamlined and efficient, ensuring timely
        delivery without compromising quality. We understand the value of your
        time and guarantee that your translations are completed within the
        agreed-upon deadlines. Confidentiality is of utmost importance to us. We
        handle your documents with care and maintain strict confidentiality
        throughout the translation process, ensuring the security of your
        sensitive information.
      </p>
    </div>
  );
};

export default TranslationProcess;
